export default __webpack_public_path__ + "static/media/card-list.e83dd985.svg";